import { SYSAction } from "../../../../../../../_ovlclient/src"
import { SortGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFormInit_Type,
  HookFormValidate_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import { FieldSetState } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

import { NewServiceStep3FormFieldKeys } from "./formdef"

const HookField_objectBuildingType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()

  return {
    //@ts-ignore
    data: state.app.global.SVL.lookups.objectBuildingType.data,
    //@ts-ignore
    lookupDef: state.app.global.SVL.lookups.objectBuildingType.lookupDef,
    sortFn: (dataA, dataB) =>
      SortGet(dataA.BuildingTypeDesc, dataB.BuildingTypeDesc),
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let fieldKey = <NewServiceStep3FormFieldKeys>value.field.fieldKey
  let field = value.formState.fields[fieldKey]
  switch (fieldKey) {
    case "agbConfirmation":
      value.validatorUse("MandatoryCheck", {
        val: false,
        validation: { displayType: "OnlyOutline" },
      })
      break
  }
}

const HookFormInit: SYSAction<HookFormInit_Type> = async (
  { formState },
  { global }
) => {
  let state = global.getState()
  let objectBuildingType = formState.fields["objectBuildingType"]
  // set fields to inactive if not used
  let foundEqipment = state.app.global.SVL.NewService.equipment.id !== ""
  FieldSetState(objectBuildingType, !foundEqipment)
}

export let hooks = {
  HookField_objectBuildingType_GetList,
  HookFormValidate,
  HookFormInit,
}
